import React from 'react';
import DashboardTemplate from '../../components/Templates/Dashboard';

const Dashboard = () => {
  return <DashboardTemplate />;
};

export default Dashboard;
